// extracted by mini-css-extract-plugin
export default {"panel":"BpJul_BpJul","panelHeader":"L1p_M_L1p_M","section":"h_TLe_h_TLe","accordionIcon":"zaG24_zaG24","accordionContent":"Nb3Wt_Nb3Wt"};